import DOMPurify, { type Config } from 'dompurify';

const domPurify = DOMPurify();

// Keep `style` on incoming HTML but restrict it to declarations the rich-text
// surface relies on: Color (text colour) and Highlight (background-color) marks
// serialise to inline style, and the Image extension's resize handle writes
// inline width/height on <img>. Without this, paste round-trips lose those.
domPurify.addHook('uponSanitizeAttribute', (_, data) => {
  if (data.attrName === 'style') {
    const safe = data.attrValue
      .split(';')
      .map((decl) => decl.trim())
      .filter((decl) => /^(color|background-color|width|height)\s*:/i.test(decl))
      .join('; ');

    if (safe) {
      data.attrValue = safe;
    } else {
      data.keepAttr = false;
    }
    return;
  }
});

const PASTE_CONFIG: Config = {
  USE_PROFILES: { html: true },
  // Drop presentational/identity carriers. Tiptap re-renders structure with its own classes.
  // Incoming class/id just adds noise and round-trip risk. `style` is handled by the hook above so colour/highlight marks survive.
  FORBID_ATTR: ['class', 'id'],
  // <font> is deprecated HTML; <style> would otherwise leak CSS rules as visible text.
  FORBID_TAGS: ['style', 'font'],
  // Allow data-s3-key attribute on images so backend can refresh S3 tokens on load.
  ADD_ATTR: ['data-s3-key'],
};

export const sanitizePastedHTML = (html: string): string => {
  if (!html) {
    return html;
  }

  return domPurify.sanitize(html, PASTE_CONFIG) as string;
};
